const CateringActionTypes = {
    FETCHING_START: 'LOGIN_START',
    FETCHING_SUCCESS: 'LOGIN_SUCCESS',
    FETCHING_FAILURE: 'LOGIN_FAILURE',
    LOGOUT: 'USER_LOGOUT', // User logs out intentionally, Local storage and all other reducers will be reset on such case
    KICK_USER_OFF: 'KICK_USER_OFF', // We kick out user, probably due to invalid token. No need to clear cart in this case, becasue user is likely to login back or checkout as guest with the current cart items
}

export default CateringActionTypes; 